'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolvers = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _utils = require('./utils');

var _mutations = require('./mutations');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resolvers = {
  Query: {
    libraries: function libraries(obj, args, _ref) {
      var library = _ref.loaders.library;
      return library.load(undefined, 'all');
    },

    library: function library(obj, args, _ref2) {
      var _library = _ref2.loaders.library;
      return _library.load(args['id']);
    },

    folder: function folder(obj, args, _ref3) {
      var _folder = _ref3.loaders.folder;
      return _folder.load(args['id']);
    },

    document: function document(obj, args, _ref4) {
      var _document = _ref4.loaders.document;
      return _document.load(args['id']);
    },

    me: function me(obj, args, _ref5) {
      var authed = _ref5.session.me.authed;
      return authed;
    }
  },

  Mutation: {
    authenticate: function authenticate(obj, args, context) {
      return (0, _mutations.auth)(args['email'], args['password'], context);
    },

    revokeSession: function revokeSession(obj, args, context) {
      return (0, _mutations.revoke)(context);
    },

    phoenixToken: function phoenixToken(obj, args, context) {
      return (0, _mutations.pnxToken)(context);
    },

    newFolder: function newFolder(obj, args, context) {
      return (0, _mutations.newFolder)(args['libraryId'], args['path'], context);
    },

    deleteFolder: function deleteFolder(obj, args, context) {
      return (0, _mutations.deleteFolder)(args['id'], context);
    },

    shareFolder: function shareFolder(obj, args, context) {
      return (0, _mutations.shareFolder)(args['id'], args['input'], context);
    },

    revokeFolderShare: function revokeFolderShare(obj, args, context) {
      return (0, _mutations.revokeFolderShare)(args['documentId'], args['shareId'], context);
    },

    shareDocument: function shareDocument(obj, args, context) {
      return (0, _mutations.shareDoc)(args['id'], args['input'], context);
    },

    revokeDocumentShare: function revokeDocumentShare(obj, args, context) {
      return (0, _mutations.revokeDocShare)(args['id'], args['shareId'], context);
    },

    deleteDocument: function deleteDocument(obj, args, context) {
      return (0, _mutations.deleteDoc)(args['id'], context);
    }
  },

  PNXToken: (0, _utils.getters)({
    token: 'Token',
    expires: function expires(obj) {
      return +new Date.parse(obj['ExpirationDate']);
    }
  }),

  Share: (0, _utils.getters)({
    id: 'ShareId',
    reference: 'ReferenceString',
    url: function url(obj) {
      return obj['Links']['WebUri'];
    }
  }),

  Authed: (0, _utils.getters)({
    token: 'delegate',
    name: 'UserName',
    id: 'UserId'
  }),

  Library: (0, _utils.getters)({
    id: 'LibraryId',
    name: 'LibraryName',
    isPrivate: 'IsPrivate',

    folders: function folders(obj, args, _ref6) {
      var libraryFolders = _ref6.loaders.libraryFolders;
      return libraryFolders.load(obj['LibraryId']);
    }
  }),

  Folder: (0, _utils.getters)({
    id: 'FolderId',
    name: 'FolderName',

    folders: function () {
      var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(obj, args, _ref8) {
        var folder = _ref8.loaders.folder;
        var f;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return folder.load(obj['FolderId'], { folders: true });

              case 2:
                f = _context.sent;
                return _context.abrupt('return', f['Embedded']['Folders']);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, undefined);
      }));

      return function folders(_x, _x2, _x3) {
        return _ref7.apply(this, arguments);
      };
    }(),

    documents: function () {
      var _ref9 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(obj, args, _ref10) {
        var folder = _ref10.loaders.folder;
        var f;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return folder.load(obj['FolderId'], { documents: true });

              case 2:
                f = _context2.sent;
                return _context2.abrupt('return', f['Embedded']['Documents']);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, undefined);
      }));

      return function documents(_x4, _x5, _x6) {
        return _ref9.apply(this, arguments);
      };
    }()
  }),

  Document: (0, _utils.getters)({
    id: 'DocumentId',
    name: 'DocumentName',
    modified: function modified(obj) {
      return +new Date(obj['DateModified']);
    }
  })
};
exports.resolvers = resolvers;


//////////////////
// WEBPACK FOOTER
// ./~/nice-sharebase/lib/resolvers.js
// module id = 551
// module chunks = 0